import { X } from "lucide-react";
import { TeamLogo } from "../../shared/team-logo";

export const HistoryItem = (props) => {
  const { item, selected, onSelect, onRemove, onMouseEnter } = props;
  
  return (
    <div
      onClick={() => onSelect(item)}
      onMouseEnter={onMouseEnter}
      className={`group flex items-center gap-2.5 px-3 py-2 cursor-pointer transition-colors border-b border-gray-100 last:border-b-0 ${
        selected ? "bg-blue-50" : "hover:bg-gray-50"
      }`}
    >
      <div className="w-7 h-7 shrink-0">
        <TeamLogo teamId={item.teamId} teamName={item.teamName} size="w-7 h-7" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium text-gray-900 truncate">{item.name}</div>
        {item.subtitle && (
          <div className="text-xs text-gray-500 truncate">{item.subtitle}</div>
        )}
      </div>
      <span
        className={`text-[10px] font-medium px-1.5 py-0.5 rounded ${
          item.type === "team" ? "bg-emerald-50 text-emerald-600" : "bg-blue-50 text-blue-600"
        }`}
      >
        {item.type === "team" ? "Team" : "Player"}
      </span>
      <button
        onClick={(e) => {
          e.stopPropagation();
          onRemove(item.id);
        }}
        className="opacity-0 group-hover:opacity-100 p-0.5 text-gray-300 hover:text-gray-500 transition-opacity"
      >
        <X className="w-3 h-3" />
      </button>
    </div>
  );
};
